module.exports = __webpack_public_path__ + "static/media/new-customer.80f0302d.svg";